import React from 'react';
import PropTypes from 'prop-types';

function RightCol(props) {
  const {
    institution,
    ip,
    contact,
    team,
    template,
  } = props;

  // Image files to use based on "template" variable.
  const images = {
    'plantilla-itcr': {
      imagesTop: [{
        file: 'logo-TEC.jpg',
        alt: 'Logo del ITCR',
      }],
      imagesBottom: [],
    },
    'plantilla-cenat-lanotec': {
      imagesTop: [{
        file: 'logo-CENAT.png',
        alt: 'Logo del CENAT',
      }],
      imagesBottom: [{
        file: 'cenat-lanotec.png',
        alt: 'Logo del LANOTEC',
      }],
    },
    'plantilla-cenat-cenibiot': {
      imagesTop: [{
        file: 'logo-CENAT.png',
        alt: 'Logo del CENAT',
      }],
      imagesBottom: [{
        file: 'logo-CENIBiot.png',
        alt: 'Logo del CENIBiot',
      }],
    },
    'plantilla-ucr': {
      imagesTop: [{
        file: 'logo-UCR.png',
        alt: 'Logo de la UCR',
      }],
      imagesBottom: [{
        file: 'proinnova.png',
        alt: 'Logo de Proinnova',
      }],
    },
    'plantilla-uned': {
      imagesTop: [{
        file: 'logo-UNED.png',
        alt: 'Logo de la UNED',
      }],
      imagesBottom: [{
        file: 'logo-DIC.png',
        alt: 'Logo de la DIC',
      }],
    },
    'plantilla-una': {
      imagesTop: [{
        file: 'logo-UNA.png',
        alt: 'Logo de la UNA',
      }],
      imagesBottom: [{
        file: 'logo-OTVE.png',
        alt: 'Logo de la OTVE',
      }],
    },
    'plantilla-una-ucr': {
      imagesTop: [{
        file: 'logo-UNA.png',
        alt: 'Logo de la UNA',
      }, {
        file: 'logo-UCR.png',
        alt: 'Logo de la UCR',
      }],
      imagesBottom: [{
        file: 'proinnova.png',
        alt: 'Logo de Proinnova',
      }],
    },
    'plantilla-ucr-itcr': {
      imagesTop: [{
        file: 'logo-UCR.png',
        alt: 'Logo de la UCR',
      }, {
        file: 'logo-TEC.jpg',
        alt: 'Logo del ITCR',
      }],
      imagesBottom: [{
        file: 'proinnova.png',
        alt: 'Logo de Proinnova',
      }],
    },
    'plantilla-inta': {
      imagesTop: [{
        file: 'logo-INTA.png',
        alt: 'Logo del INTA',
      }],
      imagesBottom: [],
    },
  };

  const institutions = institution.split('-');
  const logos = Object.prototype.hasOwnProperty.call(images, template) ? images[template] : null;
  const rightColClasses = [
    'licensed-technology-right-col',
    `licensed-technology-right-col--${institutions[0].toLowerCase()}`,
  ].join(' ');
  const contactItems = contact && (
    <div className="licensed-technology-right-col__contact">
      <h3 className="licensed-technology-right-col__label">Contacto</h3>
      {contact.map((item, index) => (
        <div className="licensed-technology-right-col__contact-item" key={index}> {/* eslint-disable-line */}
          {item.value.map((field) => {
            const contactClasses = {
              'Nombre del contacto': 'licensed-technology-right-col__contact-name',
              'Puesto del contacto': 'licensed-technology-right-col__contact-position',
              Teléfono: 'licensed-technology-right-col__contact-phone-wrapper',
              Correo: 'licensed-technology-right-col__contact-email',
              'Sitio web': 'licensed-technology-right-col__contact-website',
            };
            let content;
            switch (field.name) {
              case 'Teléfono':
                content = (
                  <span>
                    <span className="licensed-technology-right-col__contact-phone-label">Teléfono: </span>
                    <span className="licensed-technology-right-col__contact-phone">
                      {field.value}
                    </span>
                  </span>
                );
                break;
              case 'Correo':
                content = <a href={`mailto:${field.value}`}>{field.value}</a>;
                break;
              case 'Sitio web':
                var site_url = field.value;
                if (site_url.trim() != '' && site_url.indexOf('http') === -1) {
                  site_url = 'http://' + site_url.trim();
                }

                content = <a href={site_url} target="_blank">{field.value}</a>;
                break;
              case 'Fecha de nacimiento':
                content = '';
                break;
              default:
                content = field.value;
            }
            return (
              <p className={contactClasses[field.name]} key={field.name}>
                {content}
              </p>
            );
          })}
        </div>
      ))}
    </div>
  );
  const teamItems = team && (
    <div className="licensed-technology-right-col__team">
      <h3 className="licensed-technology-right-col__label">Equipo investigador</h3>
      {team.map(item => (
        item.value.map(person => (
          <div className="licensed-technology-right-col__team-item" key={person}>
            <p className="licensed-technology-right-col__team-name">
              {person}
            </p>
            <p className="licensed-technology-right-col__team-detail">
              {item.name}
            </p>
          </div>
        ))
      ))}
    </div>
  );
  const intelectualPropertyItems = ip[0].value[0].name === 'Sí'
    ? ip[0].value[0].value.map(item => (item && (
      item.name !== 'Otro'
        ? (
          <li>
            {item.name}
            {
              item.value.map((field, i) => {
                let { value } = field;
                const { name } = field;
                if (!value) return value;
                if (name.includes('Indicar número de solicitud')) {
                  value = `Nº ${value}`;
                }
                value = (!i ? `: ${value}` : `, ${value}`);
                return value;
              })
            }
          </li>
        )
        : (
          item.value[0].value.split(/\r?\n/).map(other => other && (
            <li>{other}</li>
          ))
        )
    )))
    : '';

  return (
    <div className={rightColClasses}>
      {logos && (
        <div className="licensed-technology-right-col__logo">
          {logos.imagesTop.map(logo => (logo && (
            <img
              src={`http://startups.hipatia.cr/files/soi/${logo.file}`}
              alt={logo.alt}
              key={logo.file}
            />
          )))}
        </div>
      )}
      {ip && (
        <div>
          <h3 className="licensed-technology-right-col__label">Propiedad intelectual</h3>
          <ul className="licensed-technology-right-col__list">
            { intelectualPropertyItems }
          </ul>
        </div>
      )}
      {contactItems}
      {teamItems}
      {logos && (
        <div className="licensed-technology-right-col__bottom_image">
          {logos.imagesBottom.map(logo => (logo && (
            <img
              src={`http://startups.hipatia.cr/files/soi/${logo.file}`}
              alt={logo.alt}
              key={logo.file}
            />
          )))}
        </div>
      )}
    </div>
  );
}

RightCol.propTypes = {
  institution: PropTypes.string.isRequired,
  ip: PropTypes.arrayOf(PropTypes.object).isRequired,
  contact: PropTypes.arrayOf(PropTypes.object).isRequired,
  team: PropTypes.arrayOf(PropTypes.object).isRequired,
  template: PropTypes.string.isRequired,
};

export default RightCol;
